module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal template-editor animated fadeIn",
    class: {
      'is-active': _vm.$route.path.indexOf('/template/') > -1
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('document-editor-main', {
    attrs: {
      "payload": _vm.template,
      "document-loaded": _vm.templateLoaded,
      "show-template-sidebar": _vm.showTemplateSidebar
    },
    on: {
      "update": _vm.updateDocument
    }
  }, [_c('form', {
    staticClass: "document-title-wrapper",
    attrs: {
      "slot": "document-title"
    },
    slot: "document-title"
  }, [_c('div', {
    staticClass: "label"
  }, [_c('span', {
    staticClass: "page-header",
    on: {
      "click": function($event) {
        _vm.$router.push('/a/templates')
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-arrow-left"
  }), _vm._v("\n          " + _vm._s(_vm.$t('navigation.templates')) + " /\n        ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.template.title),
      expression: "template.title"
    }],
    attrs: {
      "type": "text",
      "name": "template-title",
      "placeholder": _vm.$t('general.add_title_here')
    },
    domProps: {
      "value": (_vm.template.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.template, "title", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "click-to-edit"
  }, [_vm._v(_vm._s(_vm.$t('general.click_to_edit')))])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated slideInRight",
      "leave-active-class": "animated slideOutRight"
    }
  }, [(!_vm.showTemplateSidebar) ? _c('div', {
    staticClass: "is-hidden-mobile show-sidebar"
  }, [_c('a', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.showTemplateSidebar = true
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "icon icon-edit"
  })])])]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated slideInRight",
      "leave-active-class": "animated slideOutRight"
    }
  }, [(_vm.showTemplateSidebar) ? _c('template-editor-sidebar', {
    attrs: {
      "payload": _vm.template
    },
    on: {
      "save": function($event) {
        _vm.saveTemplate()
      },
      "update": _vm.updateDocument,
      "closeTemplateSidebar": function($event) {
        _vm.showTemplateSidebar = false
      }
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ed53d24","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/modals/template-editor-modal.vue
// module id = 543
// module chunks = 0